export default {
  // Nodes
  async getNodes(params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await this.request(`/nodes${query ? '?' + query : ''}`);
    return response.nodes || [];
  },

  // File Upload (files are now nodes with rawfile schema)
  async uploadFileAsNode(file, metadata = {}) {
    // Step 1: get a short-lived SAS write URL from the server
    const sasResp = await this.request(
      `/nodes/upload/sas?filename=${encodeURIComponent(file.name)}&content_type=${encodeURIComponent(file.type || 'application/octet-stream')}`
    );
    const { upload_url, blob_key } = sasResp;

    // Step 2: PUT the bytes straight to object storage (no Flask involved).
    //
    // Content-Type ONLY. S3 signs it into the presigned URL, so it has to match
    // what step 1 asked for. The x-ms-blob-type: BlockBlob that sat here is
    // Azure's, and it outlived the move to S3 — inert, because S3 ignores
    // unsigned headers, which is exactly why nobody noticed. Every extra header
    // is also one more thing the bucket's CORS preflight has to permit.
    const putResp = await fetch(upload_url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
      body: file,
    });
    if (!putResp.ok) {
      throw new Error(`Blob upload failed: ${putResp.status}`);
    }

    // Step 3: compute checksum and create the node record
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const checksum = Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, '0')).join('');

    return this.request('/nodes/upload', {
      method: 'POST',
      body: JSON.stringify({
        blob_key,
        filename: file.name,
        mime_type: file.type || 'application/octet-stream',
        size_bytes: file.size,
        checksum_sha256: checksum,
        metadata,
      }),
    });
  },

  async getNodeDownloadUrl(nodeId) {
    return this.request(`/nodes/${nodeId}/download`);
  },
};
